import { ReactNode } from "react";
import { PreferencesProvider } from "components/preferences";
import { SessionTimeout } from "@sagecentral/core-ui";
import Layout from "./layout";
import { Outlet } from "react-router-dom";
import { RequireAuth } from "components/auth";

const LayoutWithOutlet: React.FC<{ children?: ReactNode }> = ({ children }) => {
    const timeout: number = Number.parseInt(process.env.REACT_APP_SESSION_TIMEOUT || '30') * 60000;
    const promptBeforeIdle: number = Number.parseInt(process.env.REACT_APP_PROMPT_BEFORE_LOGOUT || '30') * 1000;

    return (
        <RequireAuth>
            <PreferencesProvider>
                <SessionTimeout timeout={timeout} promptBeforeIdle={promptBeforeIdle} />
                <Layout>
                    {children ? children : <Outlet />}
                </Layout>
            </PreferencesProvider>
        </RequireAuth>
    );
};

export default LayoutWithOutlet;